import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class RepetitionSkipForMonthlyScheduleOutOfRangeError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.repetition-skip.monthly-schedule-out-of-range');
    }
}
